// extracted by css-extract-rspack-plugin
var _1 = "iYYd20pCCREcQKrf";
var _2 = "CbW2gX6rvzUlyzUL";
var _3 = "b8okFWOpz0ovmsNh";
var _4 = "VvD7PoFpkNEGIf9S";
var _5 = "MwKtf79zU9EZGFhf";
var _6 = "LpRRZaTUFIO8z2YA";
var _7 = "IQOWn4Wf3w1Yzox4";
export { _1 as "arrow", _2 as "arrow-holder", _3 as "arrowDisabled", _4 as "galleryHolder", _5 as "singleSlide", _6 as "slider", _7 as "sliderInnerWrap" }
